import { Component, ElementRef, EventEmitter, Input, NgModule, OnInit, Output, ViewChild } from '@angular/core';
import { Event as NavigationEvent, NavigationStart, Router } from '@angular/router';

import { LoginService } from './../login/services/login.service';
import { CoreService } from './../services/core.service';
import { TournamentsService } from './../tournaments/services/tournaments.service';
// import { TournamentsService} from './../tournaments/services/tournaments.service';
declare let $;

declare let langId: any;
declare let SetLanguage: any;
declare let _sendChromeMessage: any;
@Component({
    selector: 'comp_login',
    templateUrl: './login.html',
})
export class Login implements OnInit {
    // LoginMessageActive: number = 0;
    // LoginMessage: string;
    public username;
    public password;
    public loginFirstValue;
    public loginResponse: LoginResponse;
    @Output() public userLoggedIn = new EventEmitter();
    public entry: Entry;
    public result: string[];

    public init: boolean;
    constructor(
        public loginService: LoginService,
        private router: Router,
        private coreService: CoreService,
        public tournamentsService: TournamentsService,
    ) {}
    public ngOnInit() {
        SetLanguage('', '');
        if (this.init) {
            return;
        }
        this.entry = this.getEntry();
        this.init = true;

        $('#Login_Modal')
            .modal({
                allowMultiple: true,
                closable: false,
            })
            .modal('show');

        // var un = this.getCookie("un");
        // var pw = this.getCookie("pw");

        // if (un != "")
        // {
        //    this.entry.Email = un;
        //    this.entry.Password = pw;
        //    this.tournamentsService.UserNameValue = un;
        //    this.tournamentsService.UserPasswordValue = pw;
        //    this.signIn();
        // }

        setTimeout(() => this.autoSignIn(), 6000);

        this.loginService.firstLoginReceived.subscribe(s => {
            this.tournamentsService.UserNameValue = s.username.toString();
            this.tournamentsService.UserPasswordValue = s.password.toString();
            console.warn('Login received credentials');
            this.signIn();
        });
    }

    public autoSignIn() {
        this.entry.Email = this.loginService.credentialsun;
        this.entry.Password = this.loginService.credentialspw;
        this.tournamentsService.UserNameValue = this.loginService.credentialsun;
        this.tournamentsService.UserPasswordValue = this.loginService.credentialspw;
        this.signIn();
    }

    // signIn() {
    //    this.entry.IsSubmitted = true;
    //    this.entry.IsLoading = true;
    //    if (this.entry.Email != '' && this.entry.Password != '')
    //        this.loginService.signIn(this.entry.Email, this.entry.Password, $('input[name="__RequestVerificationToken"]').val(), langId, this
    //            .entry,this);
    //    else
    //        return;
    // }
    public signIn() {
        SetLanguage('', '');
        this.entry.IsSubmitted = true;
        this.entry.IsLoading = true;
        this.entry.Email = this.tournamentsService.UserNameValue;
        this.entry.Password = this.tournamentsService.UserPasswordValue;

        if (this.entry.Email != undefined && this.entry.Password != undefined) {
            if (this.entry.Email != '' && this.entry.Password != '') {
                this.loginService.signIn(
                    this.entry.Email,
                    this.entry.Password,
                    $('input[name="__RequestVerificationToken"]').val(),
                    langId,
                    this.entry,
                    this,
                );
            } else {
                return;
            }
        }
    }
    public getEntry(): Entry {
        return {
            Email: '',
            Password: '',
            IsSubmitted: false,
            IsLoading: false,
        };
    }
    public userLoggedInSuccessfully() {
        // this.setCookie("un", this.entry.Email, "");
        // this.setCookie("pw", this.entry.Password, "");

        _sendChromeMessage({
            command: 'savecredentials',
            un: this.entry.Email,
            pw: this.entry.Password,
        });

        this.userLoggedIn.emit();
        $.ajax({
            cache: false,
            type: 'GET',
            url: '/Login/Refresh/',
            success(data) {
                $('#cont_antiforgerytoken').html(data);

                // this.loginService.CustomerActivity($('input[name="__RequestVerificationToken"]').val(), "1");
            },
            error(xhr, ajaxOptions, thrownError) {
                console.log('error');
            },
        });
    }

    public loginEntered(e) {
        if (e.keyCode == 13) {
            this.signIn();
        }
    }

    public Login_Input_Focus_Username() {
        this.tournamentsService.SignInFocusControl = 1;
    }
    public Login_Input_FocusOut_Username() {}

    public Login_Input_Focus_Password() {
        this.tournamentsService.SignInFocusControl = 2;
    }

    public Login_Input_FocusOut_Password() {}

    public Open_Keyboard() {
        $('#Login_Keyboard_Modal')
            .modal({
                closable: false,
                allowMultiple: true,
            })
            .modal('show');
    }

    public CloseKeyboard() {
        $('#LiveBets_Keyboard_Search_Modal')
            .modal({
                dimmerSettings: {
                    opacity: 0,
                },
            })
            .modal('hide');
    }

    // ShowErrorMesaage(e) {
    //    this.LoginMessageActive = e;
    // }
    // ShowErrorMesaageContent(e) {
    //    this.LoginMessage = e;
    // }

    // getLastLoginDate() {
    //    this.userLoggedIn.emit();
    //    $.ajax({
    //        cache: false,
    //        type: "GET",
    //        url: "/Login/GetLastLoginDate",
    //        success: function (data) {

    //            console.log("LOGİNDATE:", data);
    //        },

    //       })
    // }
    public LoginKeyboard_ChangeValue(e) {
        if (this.tournamentsService.UserNameValue == undefined) {
            this.tournamentsService.UserNameValue = '';
        }
        if (this.tournamentsService.UserPasswordValue == undefined) {
            this.tournamentsService.UserPasswordValue = '';
        }
        if (this.tournamentsService.SignInFocusControl == 1) {
            this.tournamentsService.UserNameValue += e;
        }
        if (this.tournamentsService.SignInFocusControl == 2) {
            this.tournamentsService.UserPasswordValue += e;
        }
    }
    public LoginKeyboard_Backspace() {
        if (this.tournamentsService.UserNameValue == undefined) {
            this.tournamentsService.UserNameValue = '';
        }
        if (this.tournamentsService.UserPasswordValue == undefined) {
            this.tournamentsService.UserPasswordValue = '';
        }

        if (this.tournamentsService.SignInFocusControl == 1) {
            if (this.tournamentsService.UserNameValue != '') {
                this.tournamentsService.UserNameValue = this.tournamentsService.UserNameValue.slice(0, -1);
            }
        }
        if (this.tournamentsService.SignInFocusControl == 2) {
            if (this.tournamentsService.UserPasswordValue != '') {
                this.tournamentsService.UserPasswordValue = this.tournamentsService.UserPasswordValue.slice(0, -1);
            }
        }
    }

    public LoginKeyboard_Close() {
        // if (this.tournamentsService.SignInFocusControl == 1) {
        //    this.tournamentsService.UserNameValue = "";
        // }
        // if (this.tournamentsService.SignInFocusControl == 2) {
        //    this.tournamentsService.UserPasswordValue = "";
        // }
        $('#Login_Keyboard_Modal').modal('hide');
    }
    public LoginKeyboard_InputClear() {
        // console.log("CLEAR");

        if (this.tournamentsService.SignInFocusControl == 1) {
            this.tournamentsService.UserNameValue = '';
        }
        if (this.tournamentsService.SignInFocusControl == 2) {
            this.tournamentsService.UserPasswordValue = '';
        }
    }
    public setCookie(name: string, value: string, path = '') {
        const d: Date = new Date();
        d.setTime(d.getTime() + 1000 * 24 * 60 * 60 * 1000);
        const expires = `expires=${d.toUTCString()}`;
        const cpath: string = path ? `; path=${path}` : '';
        document.cookie = `${name}=${value}; ${expires}${cpath}`;
    }
    public getCookie(name: string) {
        const ca: string[] = document.cookie.split(';');
        const caLen: number = ca.length;
        const cookieName = `${name}=`;
        let c: string;

        for (let i = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, '');
            if (c.indexOf(cookieName) == 0) {
                return c.substring(cookieName.length, c.length);
            }
        }
        return '';
    }
}
